import { getStore } from "../appRedux/store";
import { onboardingEvents,sessionEvents,questionEvents,inviteEvents, questionBuilderEvents } from "./events";

// eslint-disable-next-line no-undef
const _analytics = global.analytics;

const track = (event, properties = {}) => {
  _analytics.track(event,properties);
};
export const identify = (user,other={}) => {
  if (!user) return;
  // const __store = getStore()
  const { username, attributes } = user;
  const { sub, phone_number } = attributes;
  _analytics.identify(sub, {
    name: username,
    phone: phone_number,
    ...other
  });
};
export const searchedSchool = (pincode) => {
  track(onboardingEvents.ENTERED_PINCODE, { pincode });
};
export const selectedSchool = (pincode, school_id, school_name) => {
    track(onboardingEvents.SELECTED_SCHOOL,{pincode,school_id,school_name})
};
export const signupSuccessful = (userDetails) => {
    track(onboardingEvents.SIGN_UP_SUCCESSFUL,{...userDetails})
};

export const track_assignedPractice = (chapter_id,subchapter_id="",questions = [], other={}) => {
    track(sessionEvents.ASSIGNED_PRACTICE,{chapter_id,subchapter_id,questions, ...other})
};
export const viewStudentDetails = () => {};

export const track_viewedPracticeQuestions = (chapter_id,subchapter_id="",questions = [], other={}) => {
    track(sessionEvents.VIEWED_PRACTICE,{chapter_id,subchapter_id,questions,...other})
};

export const track_started_building_practice = (filters={})=>{
  track(sessionEvents.STARTED_BUILDING_PRACTICE,{...filters})
}
export const track_cancelled_building_practice = (filters={})=>{
  track(sessionEvents.CANCELLED_PRACTICE_CREATION,{...filters})
}
export const reportQuestion = (question_id,reportReason,comment)=>{
  track(questionEvents.REPORT_QUESTION,{question_id,reportReason,comment})
}
export const inviteStudent = (link,channel)=>{
  track(inviteEvents.INVITE_STUDENT,{link,channel})
}
export const clickedOnInviteStudent = ()=>{
  track(inviteEvents.CLICKED_ON_INVITE_STUDENT)
}

// question builder eventse

export const track_started_question_building = (eventData)=>{
  track(questionBuilderEvents.CLICKED_ON_ADD_QUESTION,eventData)
}
export const track_built_question_body = (eventData)=>{
  track(questionBuilderEvents.BUILT_QUESTION_BODY,eventData)
}

export const track_added_question_meta = (eventData)=>{
  track(questionBuilderEvents.ADDED_QUESTION_META,eventData)
}

export const track_saved_question = (eventData)=>{
  track(questionBuilderEvents.SAVED_QUESTION,eventData)
}

export const track_cancelled_question_building = (eventData)=>{
  track(questionBuilderEvents.CANCELLED_QUESTION_BUILDING,eventData)
}